import { z } from "zod";
import { CommunityRole } from "../enum.js";

export const updateMemberRoleSchema = z
	.object({
		role: z.enum(CommunityRole),
	})
	.strict();

export type UpdateMemberRolePayload = z.infer<typeof updateMemberRoleSchema>;
